export class StorageKey {
	public static token = 'token';
	public static userInfo = 'userInfo';
	public static platform = 'platform';
	public static planDetail = 'planDetail';
	public static isFbConnected = 'isFbConnected';
	public static isGoogleConnected = 'isGoogleConnected';
}
